export const SignUpNewsletterItemV1LocalStorageKey = "subscription_newsletterItems";

// Cspell:ignore Metrix
export const SignUpMatrixV1LocalStorageKey = "subscription_dataMetrix";

export const SignInUrl = "/centralize/signin";
